import { Resources } from 'constants/resources';

import { ADJUSTMENT_CONFIGS } from 'pages/OrderAdjustments/constants/adjustmentConfigs';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useGetList } from 'react-admin';
import { AdjustmentType } from 'types/embedded/orderAdjustments';

import { useIsOrderAdjustmentAllowed } from './useIsOrderAdjustmentAllowed';
import { useSelectedOrders } from './useSelectedOrders';

export type OrderAdjustmentType = {
  id?: string;
  description?: string;
  tooltip: string;
  isAvailable: boolean;
};

export function useGetOrderAdjustmentTypes(): OrderAdjustmentType[] {
  const { data: adjustmentTypes = [] } = useGetList<AdjustmentType>(Resources.AdjustmentTypes);
  const selectedOrders = useSelectedOrders();
  const isOrderAdjustmentAllowed = useIsOrderAdjustmentAllowed();
  const translate = useTypedTranslate();

  return ADJUSTMENT_CONFIGS.map((config) => {
    const adjustmentType = adjustmentTypes.find((type) => type.value === config.type);

    return {
      id: adjustmentType?.['@id'],
      description: adjustmentType?.description,
      tooltip: translate(config.tooltip),
      isAvailable: isOrderAdjustmentAllowed(config, selectedOrders),
    };
  });
}
